"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _dateFns = require("date-fns");

var _filesize = _interopRequireDefault(require("filesize"));

var _jsonpath = _interopRequireDefault(require("jsonpath/jsonpath.min"));

var _lodash = require("lodash");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var STANDARD_DATE = 'yyyy-MM-dd';

var dateHandler = function dateHandler(_ref) {
  var value = _ref.value,
      props = _objectWithoutProperties(_ref, ["value"]);

  switch (true) {
    case (0, _lodash.isNil)(value):
      return '';

    case (0, _dateFns.isValid)(new Date(value)):
      return (0, _dateFns.format)(new Date(value), STANDARD_DATE);

    case (0, _dateFns.isValid)((0, _dateFns.parseISO)(value)):
      return (0, _dateFns.format)((0, _dateFns.parseISO)(value), STANDARD_DATE);

    case !isNaN(parseInt(value, 10)):
      return (0, _dateFns.format)(parseInt(value, 10), STANDARD_DATE);

    default:
      {
        console.error('unhandled data', value, props);
        return value;
      }
  }
};

var Number = function Number(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      textAlign: 'right'
    }
  }, props.value);
};

var FileSize = function FileSize(_ref2) {
  var _ref2$options = _ref2.options,
      options = _ref2$options === void 0 ? {} : _ref2$options,
      props = _objectWithoutProperties(_ref2, ["options"]);

  return /*#__PURE__*/_react["default"].createElement(Number, {
    value: (0, _filesize["default"])(props.value || 0, options).toUpperCase()
  });
};

var _default = {
  bits: function bits(_ref3) {
    var value = _ref3.value,
        props = _objectWithoutProperties(_ref3, ["value"]);

    return /*#__PURE__*/_react["default"].createElement(FileSize, _extends({}, props, {
      value: (value || 0) / 8
    }));
  },
  "boolean": function boolean(_ref4) {
    var value = _ref4.value;
    return (0, _lodash.isNil)(value) ? '' : "".concat(value);
  },
  bytes: function bytes(props) {
    return /*#__PURE__*/_react["default"].createElement(FileSize, props);
  },
  date: dateHandler,
  list: function list(props) {
    var values = _jsonpath["default"].query(props.original, props.column.jsonPath);

    var total = values.length;
    var firstValue = (0, _utils.getSingleValue)(values[0]);
    return [firstValue || ''].concat(_toConsumableArray(total > 1 ? [/*#__PURE__*/_react["default"].createElement("br", {
      key: "br"
    }), '...'] : []));
  },
  number: Number
};
exports["default"] = _default;